import styled from 'styled-components';
import { UIData, useUIStore } from '../../../hooks/stores/uiStore';
import { ElementsDrawer } from './ElementsDrawer';
import { WindowDrawer } from './WindowDrawer';
import { AssetsDrawer } from './assetsDrawer/AssetsDrawer';
import { Searchbar } from '../../common/Searchbar';
import { IconButton } from '../../common/IconButton';
import { useState } from 'react';

export const Drawer = () => {
  const [UIData] = useUIStore<UIData>();
  const [searchQuery, setSearchQuery] = useState('');

  const selectPage = () => {
    switch (UIData.sidebarDrawerPage) {
      case 'elements':
        return <ElementsDrawer searchQuery={searchQuery} />;
      case 'assets':
        return <AssetsDrawer />;
      case 'window':
        return <WindowDrawer />;
    }
    return <></>;
  };

  const selectTitle = () => {
    switch (UIData.sidebarDrawerPage) {
      case 'elements':
        return 'Elements';
      case 'assets':
        return 'Assets';
      case 'window':
        return 'Window';
    }
    return '';
  };

  return (
    <Container $isDisabled={UIData.editorMode === 'simulation'}>
      <Title>{selectTitle()}</Title>
      {UIData.sidebarDrawerPage === 'elements' && (
        <Header>
          <Searchbar onChange={setSearchQuery} />
          <IconButton
            iconClassName="icon-collapse-all"
            iconSize={16}
            style={{ height: '28px' }}
            onClick={() => UIData.collapseElementTree()}
          />
        </Header>
      )}

      {selectPage()}
    </Container>
  );
};

const Container = styled.div<{ $isDisabled: boolean }>`
  user-select: none;
  box-sizing: border-box;
  width: 100%;
  min-width: 150px;
  height: 100%;

  display: flex;
  flex-direction: column;

  font-family: var(--font-1);
  color: var(--main-2);
  font-size: 13px;

  & > * {
    animation: slideLeft 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: var(--main-2);
  padding: 5px;
  border-bottom: 1px solid var(--neutral-3);
  text-align: center;
`;

const Header = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 10px;
  margin-top: 5px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
`;
